// Input: 300000
// Output: '300,000'
export function formatCount(value = '') {
  return value.toLocaleString('en-US');
}
